import React from "react";
import { useSearchParams } from "react-router-dom";
import lawService from "./customAjax";
import { useEffect } from "react";
import { useState } from "react";
import { Navigate } from "react-router-dom";

///zoom has an integration where if you get a phonecall, it can open a webpage
///we have it set up in the zoom settings to open this page, and take the phone number they call us with
//and search lawmatics for a matter with that phone number and open their "notes" tab so customer service can add notes
///you should NOT have to touch this really; I haven't touched it since i pushed it live.
function ZoomPhone() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [phoneInfo, setPhoneInfo] = useState({});
  const callerPhone = searchParams.get("callerID");
  useEffect(() => {
    let encodedPhoneNumber = decodeURIComponent(callerPhone);
    encodedPhoneNumber = encodedPhoneNumber.replace(")", "");
    encodedPhoneNumber = encodedPhoneNumber.replace("(", "");
    encodedPhoneNumber = encodedPhoneNumber.replace("-", "");
    encodedPhoneNumber = encodedPhoneNumber.replace(" ", "");
    lawService
      .getContactByPhone(encodedPhoneNumber)
      .then((r) => {
        onGetContactSuccess(r,"InheritGuard Network")
      })
      .catch((e) => {
      lawService.getFinlawContactByPhone(encodedPhoneNumber)
      .then((r)=>{
        onGetContactSuccess(r,"Finlaw Connect")
      })
      .catch((e)=>{
        onGetContactFail(encodedPhoneNumber)
      })
      });
  }, []);
  // useEffect(()=>{
  //     openToLawmatics()
  // },[phoneInfo.id])
    const onGetContactSuccess=(r,firmName)=>{
        window.open(
            `https://app.lawmatics.com/matters/${r.data.data.id}/notes`
          );
          setPhoneInfo((ps) => {
            let pd = { ...ps };
            pd.id = r.data.data.id;
            pd.phone = r.data.data.attributes.phone;
            pd.name = `${r.data.data.attributes.first_name} ${r.data.data.attributes.last_name}`;
            pd.email = r.data.data.attributes.email;
            pd.firmName=firmName
            return pd;
          });
    }
    const onGetContactFail=(encodedPhoneNumber)=>{
        setPhoneInfo((ps) => {
            let pd = { ...ps };
            pd.id = 0;
            pd.phone = encodedPhoneNumber;
            pd.name = `User Not Found`;
            pd.email = 'User Not Found';
            return pd;
          });
    }
  return (
    <div style={{ "padding-top": "100px" }}>
      <h2>Caller Information</h2>

      <ul>
        <li>
          <h4>
            Name:{" "}
            <a
              href={`https://app.lawmatics.com/matters/${phoneInfo.id}/notes`}
            >
              {phoneInfo.name}
            </a>
          </h4>
        </li>
        <li>
          <h4>Phone: {phoneInfo.phone}</h4>
        </li>
        <li>
          <h4>Email: {phoneInfo.email}</h4>
        </li>
        <li>
          <h4>Firm: {phoneInfo.firmName}</h4>
        </li>
      </ul>
    </div>
  );
}

export default ZoomPhone;
